import React from 'react';
import { Card as CardType } from '../types/game';
import './Card.css';

interface CardProps {
  card: CardType;
  onClick?: () => void;
  selected?: boolean;
  disabled?: boolean;
  combinable?: boolean;  // Можно скомбинировать с выбранной картой
  notCombinable?: boolean;  // Нельзя скомбинировать (затемнить)
  animating?: boolean;  // Анимация полёта к цели
  combining?: boolean;  // Карта участвует в комбинации (анимация увеличения)
  size?: 'small' | 'normal' | 'large';
}

export const Card: React.FC<CardProps> = ({
  card,
  onClick,
  selected = false,
  disabled = false,
  combinable = false,
  notCombinable = false,
  animating = false,
  combining = false,
  size = 'normal',
}) => {
  const levelClass = `level-${card.level}`;
  const sizeClass = `card-${size}`;

  return (
    <div
      id={`card-${card.id}`}
      className={`card ${levelClass} ${sizeClass} ${selected ? 'selected' : ''} ${disabled ? 'disabled' : ''} ${combinable ? 'combinable' : ''} ${notCombinable ? 'not-combinable' : ''} ${animating ? 'animating' : ''} ${combining ? 'combining' : ''}`}
      onClick={!disabled && !notCombinable && !animating ? onClick : undefined}
      data-card-id={card.id}
      data-card-name={card.name}
      data-card-element={card.element}
    >
      <div className="card-icon">{card.icon}</div>
      <div className="card-name">{card.name}</div>
      <div className="card-level">Ур. {card.level}</div>
    </div>
  );
};
